import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { compose, hoistStatics, lifecycle, withState, withProps } from 'recompose';
import SocialAuth from './SocialAuth';
import ModuleService from '../../services/module.service';

const mapStateToProps = state => ({
  socialAuth: state.settings.socialAuth,
  login_modules_theme: state.settings.subscriber ? state.settings.subscriber.login_modules_theme : 1,
});

const enhance = compose(
  connect(mapStateToProps),
  translate('portal'),
  withState('socials', 'setSocial', []),
  withProps(props => ({
    login_modules_theme: !props.login && !props.register ? 1 : props.login_modules_theme,
  })),
  lifecycle({
    async componentDidMount() {
      let { socialAuth } = this.props;
      if (!socialAuth || !socialAuth.length) socialAuth = await ModuleService.getSocial();
      this.props.setSocial(socialAuth || []);
    },
  }),
);

export default hoistStatics(enhance)(SocialAuth);



// WEBPACK FOOTER //
// ./src/components/socialAuth/index.js